@if (isDataSetLoaded) {
  <div class="ranked-horizontal-bar-chart">
    @if (headerColumns.length) {
      <table class="rhbc-table-layout w-full text-sm">
        <thead class="text-left">
          <tr>
            @for (col of headerColumns; track col; let i = $index) {
              <th [ngClass]="'col-' + i" class="font-bold">{{ col.label || col.name }}</th>
            }
            <th class="col-bar">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          @for (row of bodyRows; track row; let rIndex = $index) {
            <tr class="transition-colors">
              @for (cell of row; track cell; let cIndex = $index) {
                <td [ngClass]="'col-' + cIndex">
                  @if (cIndex === 1) { <!-- Title column: apply truncation & hover for full text -->
                    <span class="rhbc-title"
                          (mouseenter)="onTitleEnter($event, rIndex)"
                          (mousemove)="onTitleMove($event)"
                          (mouseleave)="onTitleLeave()">
                      {{ cell.label || cell.value }}
                    </span>
                  } @else {
                    {{ cell.label || cell.value }}
                  }
                </td>
              }
              <td class="col-bar">
                @if (barMeta[rIndex]; as b) {
                  <div class="bar-cell">
                    <div class="bar-track"
                         [style.background]="b.light"
                         (mouseenter)="onBarEnter($event, rIndex)"
                         (mousemove)="onBarMove($event)"
                         (mouseleave)="onBarLeave()">
                      <div class="bar-fill" [style.background]="b.color" [style.width.%]="b.pct"></div>
                    </div>
                  </div>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
      @if (barHoverTooltip) {
        <div class="rhbc-tooltip" [style.left.px]="tooltipX" [style.top.px]="tooltipY">
          <div class="rhbc-tooltip-row"><span class="rhbc-tooltip-label">{{ barHoverTooltip.network }}</span></div>
          <div class="rhbc-tooltip-row"><span class="rhbc-tooltip-value" [style.color]="barHoverTooltip.color">{{ barHoverTooltip.percentLabel }}</span></div>
        </div>
      }
      @if (titleHoverTooltip) {
        <div class="rhbc-tooltip" [style.left.px]="tooltipX" [style.top.px]="tooltipY">
          <div class="rhbc-tooltip-row"><span class="rhbc-tooltip-label">{{ titleHoverTooltip.title }}</span></div>
        </div>
      }
    }
  </div>
} @else {
  <div class="rhbc-loading" syncPulse>
    <table mat-table [dataSource]="placeholderData" class="w-full">
      @for (col of skeletonColumns; track col) {
        <ng-container [matColumnDef]="col">
          <th mat-header-cell *matHeaderCellDef>
            <div class="skeleton-text skw-80" syncPulse></div>
          </th>
          <td mat-cell *matCellDef="let row">
            <div class="skeleton-text skw-100" syncPulse></div>
          </td>
        </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="skeletonColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: skeletonColumns;" class="skeleton-row"></tr>
    </table>
  </div>
}
